import InvoicePreview from '../components/Invoice/InvoicePreview';

export default function InvoicePreviewPage() {
  return <InvoicePreview />;
}